<template>
  <article class="mainMessagesBox">
    <div
      @mouseenter="$store.state.utils.hoverOnNotifications = false"
      @mouseleave="$store.state.utils.hoverOnNotifications = true"
      v-for="(message, index) in $store.state.utils.notificationBox"
      :key="index"
      class="box-card"
      :style="'top: ' + 120 * index + 'px'"
    >
      <div class="box-container">
        <button class="btn canselPopup" @click="canselPopup(index)">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
            stroke-width="2"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              d="M6 18L18 6M6 6l12 12"
            />
          </svg>
        </button>
        <div class="box-icon">
          <svg
            v-if="message.type == 'info'"
            class="text-info"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M13 16h-1v-4h-1m1-4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
            />
          </svg>
          <svg
            v-if="message.type == 'warning'"
            class="text-warning"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M12 9v2m0 4h.01m-6.938 4h13.856c1.54 0 2.502-1.667 1.732-3L13.732 4c-.77-1.333-2.694-1.333-3.464 0L3.34 16c-.77 1.333.192 3 1.732 3z"
            />
          </svg>
          <svg
            v-if="message.type == 'hint'"
            class="text-primary"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M15 17h5l-1.405-1.405A2.032 2.032 0 0118 14.158V11a6.002 6.002 0 00-4-5.659V5a2 2 0 10-4 0v.341C7.67 6.165 6 8.388 6 11v3.159c0 .538-.214 1.055-.595 1.436L4 17h5m6 0v1a3 3 0 11-6 0v-1m6 0H9"
            />
          </svg>
          <svg
            v-if="message.type == 'success'"
            class="text-success"
            xmlns="http://www.w3.org/2000/svg"
            fill="none"
            viewBox="0 0 24 24"
            stroke="currentColor"
          >
            <path
              stroke-linecap="round"
              stroke-linejoin="round"
              stroke-width="2"
              d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z"
            />
          </svg>
        </div>
        <div class="box-message">
          <h4 v-if="message.title">{{ message.title }}</h4>
          <p>
            {{ message.message }}
            <a v-if="message.url" :href="message.url"> link</a>
          </p>
        </div>
      </div>
    </div>
  </article>
</template>

<script>
export default {
  name: "Notifications",
  data() {
    return {};
  },

  mounted() {
    this.$nextTick(() => {});
  },

  methods: {
    canselPopup(index) {
      this.$store.state.utils.notificationBox.splice(index, 1);
    },
  },
};
</script>

<style scoped>
.mainMessagesBox {
  position: fixed;
  z-index: 10;
  top: 0px;
  right: 0;
}
.box-card {
  position: fixed;
  z-index: 10;
  top: 0px;
  right: 0;
  width: 90%;
  max-width: 400px;
  background: #eee;
  margin: 10px;
  border-radius: 10px;
}

.box-card .box-container {
  position: relative;
  position: relative;
  display: flex;
  align-items: center;
}

.box-card .box-container .canselPopup {
  position: absolute;
  right: 0px;
  top: 0px;
}

.box-card .box-container .canselPopup svg {
  width: 20px;
}

.box-card .box-container .box-icon {
  width: 20%;
  padding: 10px;
}

.box-card .box-container .box-icon svg {
  width: 100%;
}

.box-card .box-container .box-message {
  color: #333;
}
</style>
